import React, { useState } from "react";
import HomeScreen from "../HomeScreen";
import QuizScreen from "../QuizScreen";
import ResultScreen from "../ResultScreen";

function RouterScreen() {
  const [answers, setAnswers] = useState([]);
  const [phase2Answers, setPhase2Answers] = useState([]);
  const [phase3Answers, setPhase3Answers] = useState([]);
  const [currentScreen, setCurrentScreen] = useState("Home");
  return (
    <>
      {currentScreen === "Home" && (
        <HomeScreen setCurrentScreen={setCurrentScreen} />
      )}
      {/* {currentScreen === "Tutorial" && (
        <TutorialScreen setCurrentScreen={setCurrentScreen} />
      )} */}
      {currentScreen === "Quiz" && (
        <QuizScreen
          setAnswers={setAnswers}
          setCurrentScreen={setCurrentScreen}
          setPhase2Answers={setPhase2Answers}
          setPhase3Answers={setPhase3Answers}
          answers={answers}
          phase2Answers={phase2Answers}
          phase3Answers={phase3Answers}
        />
      )}
      {currentScreen === "Result" && (
        <ResultScreen
          answers={answers}
          setAnswers={setAnswers}
          phase2Answers={phase2Answers}
          phase3Answers={phase3Answers}
          setPhase2Answers={setPhase2Answers}
          setPhase3Answers={setPhase3Answers}
          setCurrentScreen={setCurrentScreen}
        />
      )}
    </>
  );
}

export default RouterScreen;
